// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.po-profile-overlay {
    display: flex;
    flex-direction: row;
    box-shadow: 0px 0px 1px darkslategray;
}

.po-profile-photo:hover .hover-info {
    opacity: 1;
  }

.up-format-h1 {
    font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
    font-size: 60px;
    margin-top: 50px;
  }

.up-profile-header-format {
    width: 700px;
    height: 100%;
}

.up-profile-more-format {
    width: 200px;
    height: 100%;
} `, "",{"version":3,"sources":["webpack://./src/components/Pages/OverlayPage/Styles/ProfileImageUploader.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,qCAAqC;AACzC;;AAEA;IACI,UAAU;EACZ;;AAEF;IACI,6EAA6E;IAC7E,eAAe;IACf,gBAAgB;EAClB;;AAEF;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB","sourcesContent":[".po-profile-overlay {\n    display: flex;\n    flex-direction: row;\n    box-shadow: 0px 0px 1px darkslategray;\n}\n\n.po-profile-photo:hover .hover-info {\n    opacity: 1;\n  }\n\n.up-format-h1 {\n    font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;\n    font-size: 60px;\n    margin-top: 50px;\n  }\n\n.up-profile-header-format {\n    width: 700px;\n    height: 100%;\n}\n\n.up-profile-more-format {\n    width: 200px;\n    height: 100%;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
